import React, { useEffect, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import './BlogList.css';
import APIURL from '../../common/Config';
import Header from "../header/header";
import Footer from "../footer/footer";

const formatScheduleDate = (numDate) => {
    if (!numDate) return "Invalid date";
    const str = String(numDate);
    if (str.length !== 8) return "Invalid date";
    const year = str.slice(0, 4);
    const month = str.slice(4, 6);
    const day = str.slice(6, 8);
    return `${day}/${month}/${year}`;
};

const slugify = (text) =>
    (text || "")
        .toString()
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

const BlogList = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const blogsPerPage = 16;

    const staticMeta = {
        title: "Latest Astrology Blogs – Daily Horoscopes, Remedies & Zodiac Insights | AstroBhagya",
        description: "Discover the latest astrology blogs from AstroBhagya, including daily horoscopes, zodiac predictions, and spiritual remedies. Explore personalized astrological guidance for a balanced life.",
        keywords: "AstroBhagya astrology blogs, daily horoscope blog, zodiac predictions, astrology remedies, personalized horoscope, Vedic astrology blog",
        author: "Heavenly Expectation Private Limited",
        revisitAfter: "90 days",
        distribution: "global",
        rating: "general",
    };

    // const fetchBlogs = async () => {
    //     setLoading(true); 
    //     setError(null);

    //     const todayFormatted = new Date()
    //         .toISOString()
    //         .split("T")[0]
    //         .replace(/-/g, '');

    //     try {
    //         // const response = await fetch(`${APIURL}/astroblogs/by-date?startDate=20250101&endDate=20260130`);
    //         const response = await fetch(`${APIURL}/astroblogs/by-date?startDate=20250101&endDate=${todayFormatted}`);

    //         if (!response.ok) {
                
    //             throw new Error(`HTTP error! Status: ${response.status}`);
    //         }
    //         const data = await response.json();

    //         const filteredBlogs = data
    //             .filter(blog => blog.scheduleDate && blog.scheduleDate <= Number(todayFormatted)) 
    //             // .filter(blog => blog.scheduleDate && blog.scheduleDate <= 20260130)
    //             .map(blog => ({
    //                 id: blog.id,
    //                 mainHeading: blog.mainHeading,
    //                 heading: blog.heading, 
    //                 mainImageUrl: blog.mainImageUrl,
    //                 article: blog.article,
    //                 mainDescription: blog.mainDescription,
    //                 slug: blog.heading ? slugify(blog.heading) : `untitled-blog-${blog.id || Math.random()}`,
    //                 scheduleDate: blog.scheduleDate
    //             }))
    //             .sort((a, b) => b.scheduleDate - a.scheduleDate);

    //         setBlogs(filteredBlogs);
    //     } catch (err) {
    //         console.error("Error fetching blog list data:", err);
    //         setError(err.message);
    //     } finally {
    //         setLoading(false); 
    //     }
    // };

    const fetchBlogs = async () => {
    setLoading(true);
    setError(null);

    const todayFormatted = new Date()
        .toISOString()
        .split("T")[0]
        .replace(/-/g, '');

    try {
        const response = await fetch(`${APIURL}/astroblogs/by-date?startDate=20250101&endDate=${todayFormatted}`);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        
        const data = await response.json();
        
        // --- STEP 1: Sabse pehle raw data dekhte hain ---
        console.log("1. Raw API Data:", data);

        const filteredBlogs = data
            .filter(blog => blog.scheduleDate && blog.scheduleDate <= Number(todayFormatted))
            .map(blog => {
                // --- STEP 2: Har image URL ko console mein check karte hain ---
                console.log(`2. Blog ID: ${blog.id} | Image Path:`, blog.mainImageUrl);
                
                return {
                    id: blog.id,
                    mainHeading: blog.mainHeading,
                    heading: blog.heading,
                    mainImageUrl: blog.mainImageUrl, // Check if this field exists in raw data
                    article: blog.article,
                    mainDescription: blog.mainDescription,
                    slug: blog.heading ? slugify(blog.heading) : `untitled-blog-${blog.id || Math.random()}`,
                    scheduleDate: blog.scheduleDate
                };
            })
            .sort((a, b) => b.scheduleDate - a.scheduleDate);

        setBlogs(filteredBlogs);
    } catch (err) {
        console.error("Error fetching blog list data:", err);
        setError(err.message);
    } finally {
        setLoading(false);
    }
};
    useEffect(() => {
        fetchBlogs();
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 50);

        return () => clearTimeout(timer);
    }, [currentPage]);

    useEffect(() => {
        document.title = staticMeta.title;

        const setOrCreateMetaTag = (name, content) => {
            let metaTag = document.querySelector(`meta[name="${name}"]`);
            if (metaTag) {
                metaTag.setAttribute("content", content);
            } else {
                metaTag = document.createElement('meta');
                metaTag.setAttribute("name", name);
                metaTag.setAttribute("content", content);
                document.head.appendChild(metaTag);
            }
        };

        setOrCreateMetaTag("description", staticMeta.description);
        setOrCreateMetaTag("keywords", staticMeta.keywords);
        setOrCreateMetaTag("author", staticMeta.author);
        setOrCreateMetaTag("revisit-after", staticMeta.revisitAfter);
        setOrCreateMetaTag("distribution", staticMeta.distribution);
        setOrCreateMetaTag("rating", staticMeta.rating);

        let charsetMeta = document.querySelector('meta[charset]');
        if (!charsetMeta) {
            charsetMeta = document.createElement('meta');
            charsetMeta.setAttribute('charset', 'UTF-8');
            document.head.prepend(charsetMeta);
        }
    }, []);

    const indexOfLastBlog = currentPage * blogsPerPage;
    const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
    const currentBlogs = useMemo(() => blogs.slice(indexOfFirstBlog, indexOfLastBlog), [blogs, indexOfFirstBlog, indexOfLastBlog]);

    const totalPages = Math.ceil(blogs.length / blogsPerPage);

    const paginate = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxPageButtons = 5;

        if (totalPages <= maxPageButtons) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            let startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
            let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);

            if (endPage - startPage + 1 < maxPageButtons) {
                startPage = Math.max(1, endPage - maxPageButtons + 1);
            }

            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }
        }
        return pageNumbers;
    };

    
    if (loading) {
        return (
            <div className="loader-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
                <div className="spinner" style={{ border: '4px solid rgba(0, 0, 0, 0.1)', borderTop: '4px solid #3498db', borderRadius: '50%', width: '50px', height: '50px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '10px', fontSize: '1.2em', color: '#555' }}>Loading blogs...</p>
                <style>
                    {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    `}
                </style>
            </div>
        );
    }

    if (error) return <p className="error-message">Error: {error}. Please try again later.</p>;
    if (blogs.length === 0) return <p className="no-blogs-message">No blogs available at the moment. Please check back later.</p>;

    return (
        <div>
            <Header />
            <div className="blog-list-container">
                <h1 className="blog-title">BLOG UPDATES YOU CAN'T MISS</h1>
                <div className="blog-cards">
                    {currentBlogs.map(blog => (
                        <Link to={`/blogs/${blog.slug}`} key={blog.id} className="blog-card">
                          
                            {/* <img src={blog.mainImageUrl} alt={blog.mainHeading || "Blog post image"} className="blog-image" /> */}
                            <img 
    src={blog.mainImageUrl} 
    alt={blog.mainHeading || "Blog post image"} 
    className="blog-image" 
    onError={(e) => {
        console.error("3. Image Load Failed! Broken Link:", e.target.src);
    }}
/>
                            <h2 className="blog-heading">{blog.mainHeading}</h2>
                            <div className="blog-meta">
                                <span className="blog-article">{blog.article}</span>
                                <span className="blog-date">{formatScheduleDate(blog.scheduleDate)}</span>
                            </div>
                        </Link>
                    ))}
                </div>

                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="pagination-button"
                        >
                            Previous
                        </button>
                        {getPageNumbers().map(number => (
                            <button
                                key={number}
                                onClick={() => paginate(number)}
                                className={`pagination-button ${currentPage === number ? 'active' : ''}`}
                            >
                                {number}
                            </button>
                        ))}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="pagination-button"
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default BlogList;